import { render, staticRenderFns } from "./editEmployerUser.vue?vue&type=template&id=063ae4f6&scoped=true"
import script from "./editEmployerUser.vue?vue&type=script&lang=js"
export * from "./editEmployerUser.vue?vue&type=script&lang=js"
import style0 from "./editEmployerUser.vue?vue&type=style&index=0&id=063ae4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ae4f6",
  null
  
)

export default component.exports